import { Stack } from '@mantine/core';
import { Text } from '@repo/foundations';
import type { ReactNode } from 'react';

interface IssueSectionProps {
	label: string;
	value: ReactNode;
}

function IssueSection({ label, value }: IssueSectionProps) {
	return (
		<Stack spacing="3xs">
			<Text color="text/secondary/default" size="sm">
				{label}
			</Text>
			{value}
		</Stack>
	);
}

export default IssueSection;
